import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { inviteSelfProvision } from '../../../../actions/waitingArea';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { showWAInviteSelfProvison } from '../../../../actions/modal';
import { clearSearchUserForm } from 'actions/user.js';
import moment from 'moment';
import { convertToLocalMoment } from 'businessLogic/datetime';
import App from '../../../App';

export default function RightPanel(props) {
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);

  const inviteWASelfProvision = (e) => {
    if (props.selectedUsers.length == 1) {
      let cb = (result, response, invitedUser) => {
        setIsSaving(false);
        if (result) resetForm();
        const address = 'mailto:' + invitedUser.email;
        const subjectTemplate = !invitedUser.isEmailOnlyUser
          ? APP.LANGUAGE.WaitingAreaSelfProvision.ExistingUserSubject
          : APP.LANGUAGE.WaitingAreaSelfProvision.InvitedUserSubject;
        const subject =
          '?Subject=' +
          subjectTemplate.replace('##VideoCallPlatformName##', window.APP.CONFIGURATION.PORTAL.VideoCallPlatformName);

        //Means an existing user
        const body = '&body=' + formatEmailBody(invitedUser, response);
        window.location.href = address + subject + body;
      };
      setIsSaving(true);
      dispatch(inviteSelfProvision(props.selectedUsers[0], props.ifCheckboxChecked, cb));
    }
  };

  const formatEmailBody = (invitedUser, response) => {
    let body = APP.LANGUAGE.WaitingAreaSelfProvision.EmailBodyNewAccount;
    if (!invitedUser.isEmailOnlyUser) {
      body = APP.LANGUAGE.WaitingAreaSelfProvision.EmailBodyExistingUser;
    }
    const expiryTime = convertToLocalMoment(moment(response.expriyTime), props.timezone);
    const formattedExpiry = expiryTime.format(APP.LANGUAGE.WaitingAreaSelfProvision.DateFormat);
    const formattedExpiryShort = expiryTime.format(APP.LANGUAGE.WaitingAreaSelfProvision.DateFormatShort);
    body = body.replace(/##RecipientFirstName##/g, invitedUser.firstName);
    body = body.replace(/##VideoCallPlatformName##/g, window.APP.CONFIGURATION.PORTAL.VideoCallPlatformName);
    body = body.replace(/##GeneratedToken##/g, 'login?selfProvisionWA=' + response.token);
    body = body.replace(/##CurrentURL##/g, 'https://' + window.location.hostname + '/');
    body = body.replace(/##ExpiryDate##/g, formattedExpiry);
    body = body.replace(/##ExpiryDateShort##/g, formattedExpiryShort);
    body = body.replace(/##SenderName##/g, props.userName);
    //Following console log is used in E2E test case, so do not DELETE
    console.log('Token value is ' + 'https://' + window.location.hostname + '/login?selfProvisionWA=' + response.token);
    return body;
  };

  const cancelinviteWASelfProvision = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    //TODO : reset dropdown used to be here, verify we still want that window.$('.meeting-room-create-update .ui.dropdown').dropdown('clear')
    dispatch(showWAInviteSelfProvison(false));
    dispatch(clearSearchUserForm());
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';

  if (props.selectedUsers.length == 0 || !props.invalidUserEmails) {
    saveClasses += ' disable';
  }
  return (
    <div>
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="2"
          type="button"
          onClick={inviteWASelfProvision}
          data-group="inviteWASelfProvisionForm"
          className={isSaving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.WaitingAreaSelfProvision.InviteButton}
          <i className="plus  icon" />
        </button>
        <button
          tabIndex="3"
          type="button"
          onClick={cancelinviteWASelfProvision}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div
        className="ui segment ignored info attached borderless bg-transparent before-calls-bottom"
        style={{ top: '4px' }}
      >
        <div>
          <i className="ui icon info circle mrrnull pdrxs text-size-xxl mrbxs span-like" />
          <div>
            <div className="color-info mrts">
              <span>
                {APP.LANGUAGE.WaitingAreaSelfProvision.InviteDetail.replace(
                  /##PortalName##/g,
                  window.APP.CONFIGURATION.PORTAL.Name
                )}
              </span>
            </div>
            <div className="color-info mrts">
              <span>{APP.LANGUAGE.WaitingAreaSelfProvision.InviteDetailMore}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
